/* eslint-disable @typescript-eslint/no-explicit-any */

export default function (auth_id: string) {
  const { api_endpoint } = useRuntimeConfig().public

  const url = `${api_endpoint}/user/${auth_id}`

  console.log(url)

  async function update(input: any) {
    return await $fetch(url, {
      method: 'PATCH',
      body: input,
    })
  }

  async function action(input: any) {
    return await $fetch(`${url}/action`, {
      method: 'POST',
      body: input,
    })
  }

  async function get() {
    return await $fetch(url, {
      method: 'GET',
    })
  }

  async function sign(body: any) {
    await $fetch(`${api_endpoint}/user`, {
      method: 'POST',
      body,
    })
  }

  async function ticket(body: any) {
    await $fetch(`${api_endpoint}/ticket`, {
      method: 'POST',
      body,
    })
  }

  async function unsubscribe() {
    // await $fetch(`${api_endpoint}/user/${user_id}`, { method: 'DELETE' })
  }

  return {
    update,
    get,
    sign,
    ticket,
    action,
    unsubscribe,
  }
}
